<canvas class="canvas" #landscape aria-hidden="true"></canvas>
<div class="shade"></div>
<section class="hero-copy" aria-labelledby="hero-title">
  <div class="eyebrow">{{ 'user.login.scene.eyebrow' | transloco }}</div>
  <h1 id="hero-title">{{ 'user.login.scene.headlineLine1' | transloco }}<br>{{ 'user.login.scene.headlineLine2' | transloco }} <em>{{ 'user.login.scene.headlineEmphasis' | transloco }}</em></h1>
  <p>{{ 'user.login.scene.descriptionLine1' | transloco }}<br>{{ 'user.login.scene.descriptionLine2' | transloco }}</p>
</section>
<div class="car-wrap" #carWrap>
  <div class="car-body">
    <div class="car-shadow"></div>
    <img class="car-reflection" src="assets/img/login/gt-pilot-concept.webp" alt="">
    <img class="car-image" src="assets/img/login/gt-pilot-concept.webp" alt="">
    <div class="wheel left"><div class="spokes"></div></div>
    <div class="wheel right"><div class="spokes"></div></div>
    <div class="tail"></div>
    <div class="flash"></div>
    <span class="exhaust-port left" aria-hidden="true"></span>
    <span class="exhaust-port right" aria-hidden="true"></span>
    <span class="vanishing-mark" aria-hidden="true"></span>
  </div>
  <button type="button" class="car-button" [attr.aria-label]="'user.login.scene.carButton' | transloco"
    (pointerdown)="onCarPointerDown($event)" (pointerup)="stopTwoStep()" (pointercancel)="stopTwoStep()"
    (lostpointercapture)="stopTwoStep()" (keydown)="onCarKeyDown($event)" (keyup)="onCarKeyUp($event)"
    (blur)="stopTwoStep()" (contextmenu)="$event.preventDefault()"></button>
</div>
<canvas class="canvas fx" #effects aria-hidden="true"></canvas>
<div class="hero-note">
  <svg viewBox="0 0 24 24" aria-hidden="true"><path d="m9 3 8 8-5 1 2 6-3 1-2-6-4 3Z"/></svg>
  {{ 'user.login.scene.heroNote' | transloco }}
</div>
